import _ from 'lodash';
import { useCallback } from 'react';
import Axis, { LABEL_ORIENTATION } from '../../../common/d3/Axis';
import { AxesLabel } from './axes-label.component';
import { useOffscreenWidth } from './base-cartesian-chart.hook';
import { LabelToolTip } from './base-cartesian-chart.styles';
import {
  ANGLED_TEXT_AXIS_LABEL_PADDING,
  LABEL_TOOLTIP_HEIGHT,
} from '../../../common';
import { isDashletMode } from '../../../auth';

export const HorizontalAxis = ({
  onScroll,
  chartWidth,
  chartHeight,
  xLabelXLoc,
  hideAxisTickLabels,
  showAxesToolTipBottom,
  hideAxesToolTipBottom,
  onMouseOver,
  xAxisLabel,
  querySort,
  showAxisToolTipBottom,
  scale,
  ticks,
  height,
  orient,
  scrolling,
  textOrientation,
  mutedLine,
  wrapTextWidth,
  transform,
  tickSizeInner,
  chartPadding,
  isMobile,
  tickFormat,
  getOffscreenDimensionsAsync,
  showAxisBaseline,
  scrollPctLeft,
}) => {
  const offscreenWidth = useOffscreenWidth({ getOffscreenDimensionsAsync });
  let scrollLeft = Math.min(
    0,
    Math.max(-(offscreenWidth * scrollPctLeft), -offscreenWidth),
  );
  scrollLeft = _.isFinite(scrollLeft) ? scrollLeft : 0;
  const scrollCb = useCallback(
    scrollPctLeft => {
      onScroll(scrollPctLeft, 0);
    },
    [onScroll],
  );

  const angledTextPadding =
    textOrientation === LABEL_ORIENTATION.ANGLED
      ? ANGLED_TEXT_AXIS_LABEL_PADDING
      : 0;
  const mobileAngledTextPadding =
    textOrientation === LABEL_ORIENTATION.ANGLED
      ? ANGLED_TEXT_AXIS_LABEL_PADDING * 0.25
      : -5;

  const adjustedYLabelLoc =
    xLabelXLoc +
    (isDashletMode() ? mobileAngledTextPadding : angledTextPadding);

  return (
    <Axis
      mutedLine={mutedLine}
      scrolling={scrolling}
      ticks={ticks}
      height={height}
      querySort={querySort}
      orient={orient}
      textOrientation={textOrientation}
      wrapTextWidth={wrapTextWidth}
      transform={transform}
      tickSizeInner={tickSizeInner}
      chartPadding={chartPadding}
      tickFormat={tickFormat}
      showAxisBaseline={showAxisBaseline}
      scrollable='true'
      onScroll={scrollCb}
      chartWidth={chartWidth}
      chartHeight={chartHeight}
      scrollPct={scrollPctLeft}
      scrollLeft={scrollLeft}
      hideAxisTickLabels={hideAxisTickLabels}
      onMouseOver={onMouseOver}
      scale={scale}
      isMobile={isMobile}
    >
      <AxesLabel
        onMouseEnter={showAxesToolTipBottom}
        onMouseLeave={hideAxesToolTipBottom}
        width={chartWidth}
        rotate={0}
        x={0}
        y={adjustedYLabelLoc}
        label={xAxisLabel}
        isMobile={isMobile}
      />
      <LabelToolTip
        show={showAxisToolTipBottom}
        height={LABEL_TOOLTIP_HEIGHT}
        width={chartWidth}
        arrow='bottom'
        xPos={0}
        y={0}
      >
        {xAxisLabel}
      </LabelToolTip>
    </Axis>
  );
};
